<template>
    <div>
        <h3 class="mt-0">
            {{ $l10n.__('Affichage des données sur mes documents') }}
        </h3>

        <p>
            {{
                $l10n.__(
                    "Les informations que vous choisissez d'afficher sur vos documents seront également affichées sur les documents de vos collaborateurs n'ayant pas accès aux préférences générales.",
                )
            }}
        </p>

        <el-checkbox-group v-model="document">
            <div class="form-group">
                <el-checkbox label="identity">{{
                    $l10n.__('Mon identité (prénom et nom)')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="email">{{ $l10n.__('Mon adresse email') }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="phone">{{
                    $l10n.__('Mon numéro de ligne directe')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="parent">{{
                    $l10n.__('Afficher le document parent sur le pdf')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="mobile">{{ $l10n.__('Mon numéro de portable') }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="fax">{{ $l10n.__('Mon numéro de fax') }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="address">{{ $l10n.__('Mon adresse') }}</el-checkbox>
            </div>
        </el-checkbox-group>

        <p>
            {{
                $l10n.__(
                    "Vous pouvez ensuite modifier ces préférences lors de l'édition de documents",
                )
            }}
        </p>

        <h3>
            {{ $l10n.__('Affichage des colonnes') }}
        </h3>

        <p>
            {{
                $l10n.__(
                    'Les mentions que vous souhaitez afficher ou non par défaut sur vos documents pourront être réglées en fonction de vos clients (dans les préférences de chacun de vos clients) et pour chaque document.',
                )
            }}
        </p>

        <el-checkbox-group v-model="column">
            <div class="row">
                <div class="form-group">
                    <el-checkbox label="reference">{{
                        $l10n.__('Afficher la colonne Référence')
                    }}</el-checkbox>
                </div>
                <div v-if="shouldShowDescription" class="form-group" >
                    <el-checkbox label="description">{{
                        $l10n.__('Afficher la colonne Description')
                    }}</el-checkbox>
                </div>
                <div class="form-group">
                    <el-checkbox label="unit">{{
                        $l10n.__('Afficher la colonne prix unitaire')
                    }}</el-checkbox>
                </div>
                <div class="form-group">
                    <el-checkbox label="vat">{{ $l10n.__('Afficher la colonne TVA') }}</el-checkbox>
                </div>
                <div class="form-group">
                    <el-checkbox label="quantity">{{
                        $l10n.__('Afficher la colonne Quantité')
                    }}</el-checkbox>
                </div>
                <div class="form-group">
                    <el-checkbox label="paymentDate">{{
                        $l10n.__('Afficher la date de validité')
                    }}</el-checkbox>
                </div>
                <div class="form-group">
                    <el-checkbox label="totals">{{
                        $l10n.__('Afficher les totaux du document')
                    }}</el-checkbox>
                </div>
                <div class="form-group">
                    <el-checkbox label="taxes">{{
                        $l10n.__('Afficher les taxes du document')
                    }}</el-checkbox>
                </div>
                <div class="form-group">
                    <el-checkbox label="taxFree">{{
                        $l10n.__('Afficher la colonne Montant')
                    }}</el-checkbox>
                </div>
                <div class="form-group">
                    <el-checkbox label="image">{{
                        $l10n.__('Afficher la colonne Image')
                    }}</el-checkbox>
                </div>
                <div class="form-group">
                    <el-checkbox label="discount">{{
                        $l10n.__('Afficher la colonne Remise')
                    }}</el-checkbox>
                </div>
                <div class="form-group">
                    <el-checkbox label="payment">{{
                        $l10n.__('Afficher les infos de Paiement')
                    }}</el-checkbox>
                </div>
            </div>

            <p class="explain">
                {{
                    $l10n.__(
                        'Vous pouvez activer le masquage des informations tarifaires sur vos bons de livraison. Celui ci sera prioritaire par rapport au masquage des colones défini ci dessus.',
                    )
                }}
            </p>

            <div class="row">
                <div class="form-group">
                    <el-checkbox label="priceOnDelivery">{{
                        $l10n.__('Afficher les informations tarifaires sur les bons de livraisons')
                    }}</el-checkbox>
                </div>
            </div>

            <p class="explain">
                {{
                    $l10n.__(
                        "Vous pouvez choisir d'afficher par défaut vos coordonnées bancaire sur tous vos documents (cette préférence est modifiable par document",
                    )
                }}
            </p>

            <div class="row">
                <div class="form-group">
                    <el-checkbox label="bankAccount">{{
                        $l10n.__('Afficher par défaut mes coordonnées bancaires sur les documents')
                    }}</el-checkbox>
                </div>
                <div class="form-group">
                    <el-checkbox label="checkOrder">{{
                        $l10n.__('Afficher par défaut mon libellé de chèque sur les documents')
                    }}</el-checkbox>
                </div>
            </div>
        </el-checkbox-group>

        <h3>
            {{ $l10n.__('Précision des colonnes de documents') }}
        </h3>

        <p v-html="prefMessage"></p>

        <div class="label-input">
            <span>{{ $l10n.__('Précision de la colonne quantité') }}</span>
            <el-select v-model="precision" class="inline">
                <el-option
                    v-for="value in precisionList"
                    :key="value"
                    :label="formatPrecision(value)"
                    :value="value"
                >
                </el-option>
            </el-select>
        </div>

        <h3>
            {{ $l10n.__('Affichage des informations produits') }}
        </h3>

        <el-checkbox-group v-model="catalog">
            <div class="form-group">
                <el-checkbox label="number">{{
                    $l10n.__('Afficher le nombre de produits du document sur le PDF')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="weight">{{
                    $l10n.__('Afficher le poids des produits du document sur le PDF')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="default">{{
                    $l10n.__('Afficher les paramètres de lignes par défaut')
                }}</el-checkbox>
            </div>
        </el-checkbox-group>

        <h3>
            {{ $l10n.__('Affichage des informations client') }}
        </h3>

        <el-checkbox-group v-model="third">
            <div class="form-group">
                <el-checkbox label="contact">{{
                    $l10n.__('Afficher par défaut le nom du contact client sur le PDF')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="signatureOnDelivery">{{
                    $l10n.__('Afficher la signature du client sur les bons de livraison')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="signatureOnOrder">{{
                    $l10n.__('Afficher la signature du client sur les bons de commande')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="signatureOnEstimate">{{
                    $l10n.__('Afficher la signature du client sur les devis')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="phone">{{
                    $l10n.__('Afficher numéro de téléphone du client')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="vat">{{
                    $l10n.__('Afficher le numéro de TVA intra du client sur le document')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="siret">{{
                    $l10n.__('Afficher le numéro de siret du client sur le document')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="siren">{{
                    $l10n.__('Afficher le numéro de siren du client sur le document')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="reference">{{
                    $l10n.__('Afficher la référence du client sur le document')
                }}</el-checkbox>
            </div>
        </el-checkbox-group>

        <h3>
            {{ $l10n.__('Libellé de votre interlocuteur') }}
        </h3>

        <div class="label-input">
            <span>{{ $l10n.__('Libellé de votre interlocuteur') }}</span>
            <el-select v-model="speaker" class="inline">
                <el-option
                    v-for="(value, index) in speakerList"
                    :key="index"
                    :label="value.value"
                    :value="index"
                >
                </el-option>
            </el-select>
            <CompassButton
                :label="$t.__('common.actions.edit')"
                type="tertiary"
                onclick="Prefs.editValuesList('docspeakers');"
            />
        </div>

        <h3>
            {{ $l10n.__('Affichage des codes barres sur les documents') }}
        </h3>

        <p>
            {{
                $l10n.__(
                    'Vous pouvez choisir d’afficher les codes barres ainsi que les images de ceux-ci à la suite de la description de vos produits.',
                )
            }}
        </p>

        <el-checkbox-group v-model="barcode">
            <div class="form-group">
                <el-checkbox label="value">{{
                    $l10n.__('Ajouter les valeurs de codes barres dans la description des produits')
                }}</el-checkbox>
            </div>
            <div class="form-group">
                <el-checkbox label="image">{{
                    $l10n.__('Ajouter les codes barres dans la description des produits')
                }}</el-checkbox>
            </div>
        </el-checkbox-group>

        <doc-page-footer-pref v-if="!loading" v-model="footerAuto" :langs="langs" />

        <div class="mt-3">
            <CompassButton :label="$t.__('common.actions.save')" @click.prevent="save" />
        </div>
    </div>
</template>

<script>
import DocPageFooterPref from './DocPageFooterPref.vue';
import Feature from 'Services/Feature';

export default {
    components: {
        DocPageFooterPref,
    },
    props: {
        defaultDocument: {
            type: Array,
            required: true,
        },
        defaultCatalog: {
            type: Array,
            required: true,
        },
        defaultBarcode: {
            type: Array,
            required: true,
        },
        defaultThird: {
            type: Array,
            required: true,
        },
        defaultColumn: {
            type: Array,
            required: true,
        },
        defaultPrecision: {
            type: String,
            required: true,
        },
        precisionList: {
            type: Array,
            required: true,
        },
        defaultSpeaker: {
            type: String,
            required: true,
        },
        speakerList: {
            type: Object,
        },
        defaultFooterAuto: {
            type: Boolean,
            required: true,
        },
        defaultFooterTranslations: {
            type: [Array, Object],
            required: true,
        },
        docPrefsId: {
            type: Number,
            required: true,
        },
    },
    data: function () {
        return {
            loading: false,
            document: this.defaultDocument,
            catalog: this.defaultCatalog,
            barcode: this.defaultBarcode,
            third: this.defaultThird,
            column: this.defaultColumn,
            precision: this.defaultPrecision,
            speaker: this.defaultSpeaker,
            payment: this.defaultPayment,
            footerAuto: true,
            langs: [],
            defaultColumns: this.defaultColumn ,
        };
    },
    computed: {
        prefMessage() {
            return this.$l10n.__(
                'Vous pouvez modifier les précisions de chaque colonne de vos documents. Cela viendra surcharger la précision par défaut que vous avez définie dans %(startlink)s vos préférences générales %(endlink)s',
                {
                    startlink: '<a href="?_f=dataPreferences&action=dataFormat" target="_blank">',
                    endlink: '</a>',
                },
            );
        },
        shouldShowDescription() {
            return !this.defaultColumns.includes('description') &&
                !Feature.isEnabled('force-description-column-in-docrows')
        },
    },
    created() {
        this.footerAuto = this.defaultFooterAuto;
        this.getLangs();
    },
    methods: {
        addLang(lang) {
            this.langs.push({
                ...lang,
                content: !_.isNil(
                    Object.keys(this.defaultFooterTranslations).find((key) => +key === lang.id),
                )
                    ? this.defaultFooterTranslations[lang.id]
                    : '',
            });
        },
        getLangs() {
            this.loading = true;
            this.$ajax.get(
                this.$router.resolve({ name: 'legacy.settings.lang' }).href,
                {},
                (response) => {
                    response.forEach((lang) => this.addLang(lang));
                    this.loading = false;
                },
            );
        },
        formatPrecision: function (value) {
            return value === 'default' ? this.$l10n.__('Valeur par défaut') : value;
        },
        save: function () {
            let options = {
                document: this.document,
                catalog: this.catalog,
                barcode: this.barcode,
                third: this.third,
                column: this.column,
                precision: this.precision,
                speaker: this.speaker,
                payment: this.payment,
                footerAuto: this.footerAuto,
                translations: {},
            };

            this.langs.forEach((lang) => {
                options.translations[lang.id] = lang.content;
            });

            this.$ajax.put(
                this.$router.resolve({
                    name: 'legacy.settings.display.preferences',
                    params: { docPrefsId: this.docPrefsId },
                }).href,
                {},
                options,
                (data) => {
                    this.defaultColumns = this.column
                    Push.success(this.$l10n.__('Préférences enregistrées'));
                },
                (error) => {
                    let errors = {};
                    const messages = error.response.data.error.message;
                    Object.keys(messages).forEach(function (key) {
                        Push.error(messages[key]);
                    });
                },
            );
        },
    },
};
</script>
